import { SET_DETAIL_STORY } from "../actions/action-types.js";

export default function detailStory(state = {item: [], others: []}, {type, payload}) {
    switch (type) {
        case SET_DETAIL_STORY:
            return (state = {...state, item: payload.item, others: payload.others})
        default:
            return state
    }
}